import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";

import baseFilesReducer from "./slices/baseFilesSlice";
import clientDetailsReducer from "./slices/clientDetailsSlice";
import userFilesReducer from "./slices/userFilesSlice";
import userReducer from "./slices/userSlice";
const reducers = combineReducers({
  user: userReducer,
  baseFiles: baseFilesReducer,
  userFiles: userFilesReducer,
  clientDetails: clientDetailsReducer,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const config = {
  blacklist: ["persist/PERSIST", "persist/REHYDRATE"],
};
const synckStateMiddleware = [createStateSyncMiddleware(config)];

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(synckStateMiddleware),
});

initMessageListener(store);

export const persistor = persistStore(store);
